import React from 'react';
import FloatingPanel from '../../../../../../components/tooltips/FloatingPanel';
import { TooltipAlignment, TooltipPositions } from '../../../../../../components/tooltips/tooltipConstants';
import PopupPanelMouseManager from '../../../../../../components/popupPanel/PopupPanelMouseManager';
import { PopupIds } from '../../../../../../components/popupPanel/popupConstants';
import LabelColorPicker from '../components/LabelColorPicker';
import { LabelEditContentProps } from '../labelComponentPropTypes';

const LabelColorPopup: React.FC<Omit<LabelEditContentProps, 'labeledElements' | 'boardVirtualPathToRootMap'>> = ({
    label,
    showColorMenu,
    updateLabel,
}) => {
    if (!label) return null;

    return (
        <div className="LabelColorPopup">
            <FloatingPanel
                className="light !w-auto"
                selector={`#label-color-${label.id}`}
                pollPosition
                offset={20}
                showArrow={false}
                distance={0}
                alignment={TooltipAlignment.START}
                position={TooltipPositions.RIGHT}
                show={showColorMenu}
            >
                <PopupPanelMouseManager
                    visible={showColorMenu}
                    popupId={PopupIds.LABEL_EDIT_COLOR}
                    closePopup={() => {}}
                >
                    <div className="mb-3 mt-3">
                        <LabelColorPicker label={label} updateLabel={updateLabel} />
                    </div>
                </PopupPanelMouseManager>
            </FloatingPanel>
        </div>
    );
};

export default LabelColorPopup;
